import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';
import { useDispatch } from 'react-redux';

const changeResponsible = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/executors/${shutdownId}`,
    data,
    'Не удалось изменить список ответственных',
    'Error'
  );

  return res;
};

export const useShutdownResponsibleChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeResponsible, {
    ...options,
    onSuccess: async (res, { shutdownId }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
